import React from 'react';
import { Link } from 'react-router-dom';

const footerTextShadow = '0 1px 3px rgba(0,0,0,0.3), 0 2px 6px rgba(0,0,0,0.25)';
const titleStyle = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  letterSpacing: '0.05em',
};

export default function Footer() {
  return (
    <footer className="relative py-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8 relative">
        <div className="rounded-2xl py-8 px-6 md:px-10" style={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 
              className="text-2xl font-bold mb-4 text-gray-700"
              style={titleStyle}
            >
              Web Service
            </h3>
            <p className="mb-4" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
              We don't just build <i><b>websites</b></i>, we build <i><b>systems</b></i> to generate leads and clients so you don't have to.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 
              className="text-xl font-bold mb-4 text-gray-700"
              style={titleStyle}
            >
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  Services
                </Link>
              </li>
              <li>
                <Link to="/book" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  Book
                </Link>
              </li>
              <li>
                <Link to="/aboutme" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  About
                </Link>
              </li>
              <li>
                <Link to="/contactme" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/accessibility" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  Accessibility
                </Link>
              </li>
              <li>
                <Link to="/ada-compliant" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  ADA Statement
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 
              className="text-xl font-bold mb-4 text-gray-700"
              style={titleStyle}
            >
              Services
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  Web Design
                </Link>
              </li>
              <li>
                <Link to="/services" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  Development
                </Link>
              </li>
              <li>
                <Link to="/services" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  SEO
                </Link>
              </li>
              <li>
                <Link to="/services" className="transition-colors hover:opacity-70" style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                  Maintenance
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 
              className="text-xl font-bold mb-4 text-gray-700"
              style={titleStyle}
            >
              Contact
            </h3>
            <ul className="space-y-2">
              <li style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                Email: zarafairooz@webanova.studio
              </li>
              <li style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                Phone: (818) 641-9709
              </li>
              <li style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', textShadow: footerTextShadow }}>
                Location: Los Angeles, CA
              </li>
            </ul>
          </div>
        </div>
        </div>

        <div className="border-t border-black/20 mt-12 pt-8 text-center">
          <p style={{ fontFamily: "'Poppins', sans-serif", color: '#000000', opacity: 0.8, textShadow: footerTextShadow }}>
            &copy; {new Date().getFullYear()} Web Service. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
} 